import { useNavigate } from "react-router-dom";
import { ReactComponent as BackButtonLogo } from '../../../assets/svg/left-arrow.svg';
import styled from "styled-components";
import { COLORS } from "../../../constants";

const Container = styled.div`
  display: flex;
  padding: 20px 20px 20px 20px;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  background: #F9F2F2;
`;

const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const SubTitle = styled.h2`
  position: relative;
  top: 25px;
  left: -120px;
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;


const BackButton = ({ title = "", desc }: { title: string, desc?: string }) => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
  
  return (
    <Container>
      <BackButtonLogo className="clickable" onClick={goBack} />
      <Title>{title}</Title>
      {desc && <SubTitle>{desc}</SubTitle>}
    </Container>
  )
}

export default BackButton;